import template from './disabled-warning.jade';
import disabledWarning from './disabled-warning.controller';

export default function () {
  return {
    template,
    scope: {},
    bindToController: {},
    controller: disabledWarning,
    controllerAs: 'disabledWarning',
    replace: true,
  };
}
